module.exports = __webpack_public_path__ + "images/park-west-be9d6b558a3785a12afe6635951dc2b5.jpg";